/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { AxiosResponse } from 'axios';
import { LuisConstants } from 'src/core/utils/LuisConstants';

/**
 * Calculates the duration that the next call should wait
 * from the `Retry-After` header.
 *
 * @param response The response to calculate the delay
 * duration depending on.
 */
const retryAfterHeaderDelayStrategy = (response: AxiosResponse): string =>
    response.headers[LuisConstants.OperationHeaders.RetryAfterHeader];

/**
 * Calculates the duration that the next call should wait
 * exponentially from the number of tries.
 */
const exponentialDelayStrategy = (_: object, trial: number): number => Math.exp((trial % 13) * 0.3) * 1000;

/**
 * An object that has the possible delay strategies.
 */
export const OperationDelayStrategies = { retryAfterHeaderDelayStrategy, exponentialDelayStrategy };
